var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketWizard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60.0001C46.5685 60.0001 60 46.5686 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5686 13.4315 60.0001 30 60.0001Z",
    fill: "#0061611a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_885_39885)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.24121,
    y: 17.7588,
    width: 43,
    height: 24,
    rx: 5,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9448 42.8263H13.0553C10.2678 42.8263 8 40.5587 8 37.771V22.2288C8 19.4413 10.2678 17.1736 13.0553 17.1736H46.945C49.7325 17.1736 52.0001 19.4414 52.0001 22.2288V23.9227C52.0001 24.5725 51.4731 25.0994 50.8233 25.0994C50.1736 25.0994 49.6465 24.5724 49.6465 23.9227V22.2288C49.6465 20.7391 48.4345 19.5271 46.945 19.5271H13.0553C11.5655 19.5271 10.3536 20.7391 10.3536 22.2288V37.7711C10.3536 39.2609 11.5655 40.4728 13.0553 40.4728H46.945C48.4345 40.4728 49.6465 39.2609 49.6465 37.7711V37.2811C45.8413 37.0383 42.82 33.8655 42.82 30C42.82 29.3501 43.347 28.8232 43.9968 28.8232C44.6467 28.8232 45.1736 29.3502 45.1736 30C45.1736 32.7253 47.3908 34.9425 50.1161 34.9425C50.2992 34.9425 50.4917 34.931 50.6885 34.9083C51.0213 34.8701 51.3559 34.9756 51.6063 35.1989C51.8568 35.4222 52.0002 35.7418 52.0002 36.0774V37.7712C51.9999 40.5587 49.7323 42.8263 46.9448 42.8263Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7017 23.9433C36.0518 23.9433 35.525 23.4163 35.525 22.7664V19.2134C35.525 18.5635 36.0519 18.0366 36.7017 18.0366C37.3515 18.0366 37.8785 18.5636 37.8785 19.2134V22.7664C37.8785 23.4164 37.3516 23.9433 36.7017 23.9433Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7017 32.9534C36.0518 32.9534 35.525 32.4264 35.525 31.7765V28.2235C35.525 27.5736 36.0519 27.0466 36.7017 27.0466C37.3515 27.0466 37.8785 27.5736 37.8785 28.2235V31.7765C37.8785 32.4264 37.3516 32.9534 36.7017 32.9534Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7017 41.9633C36.0518 41.9633 35.525 41.4363 35.525 40.7865V37.2334C35.525 36.5835 36.0519 36.0566 36.7017 36.0566C37.3515 36.0566 37.8785 36.5836 37.8785 37.2334V40.7865C37.8785 41.4365 37.3516 41.9633 36.7017 41.9633Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8174 23.7629H14.2253V36.2368H28.8174V23.7629Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8174 37.4137H14.2253C13.5754 37.4137 13.0486 36.8868 13.0486 36.237V23.763C13.0486 23.1131 13.5755 22.5862 14.2253 22.5862H28.8174C29.4673 22.5862 29.9942 23.1131 29.9942 23.763V36.2369C29.9942 36.8868 29.4673 37.4137 28.8174 37.4137ZM15.4021 35.0602H27.6406V24.9398H15.4021V35.0602Z",
    fill: "#006363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_39885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketWizard);
export default __webpack_public_path__ + "static/media/ticket-wizard.055c7ec2a071ddb90a0f2bd77dc0c183.svg";
export { ForwardRef as ReactComponent };